import { useCallback, useEffect, useState } from 'react';

import { fetchProviderStatus } from 'api/providerStatus';
import useAuth from 'hooks/useAuth';
import { normalizeProviderStatusResponse } from './model';

const PROVIDER_STATUS_POLL_MS = 60000;

export default function useProviderStatus() {
  const { isLoggedIn, user } = useAuth();
  const enabled = Boolean(isLoggedIn || user?.user_id || user?.id);
  const [status, setStatus] = useState(() => normalizeProviderStatusResponse());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) {
      setStatus(normalizeProviderStatusResponse());
      setLoading(false);
      setError(null);
      return;
    }

    try {
      const data = await fetchProviderStatus();
      setStatus(normalizeProviderStatusResponse(data));
      setError(null);
    } catch (err) {
      setError(err);
      setStatus(normalizeProviderStatusResponse());
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return undefined;
    const intervalId = window.setInterval(refresh, PROVIDER_STATUS_POLL_MS);
    return () => window.clearInterval(intervalId);
  }, [enabled, refresh]);

  return {
    ...status,
    enabled,
    loading,
    error,
    refresh
  };
}
